import type { PayoutWithJoins } from '../../custom_types'
import type { Tables } from '../../db_types'

type ManualPayoutLike =
  | Pick<Tables<'payouts'>, 'compensation_rule_id' | 'target_id' | 'payout_discrepancy_id'>
  | PayoutWithJoins
type ClawbackPayoutLike = Pick<Tables<'payouts'>, 'clawback_id'> | PayoutWithJoins
type InformativePayoutRule = Pick<
  Tables<'compensation_rules'>,
  'long_term_balancing_clawback_method' | 'long_term_balancing_period'
>
type InformativePayoutLike = Pick<Tables<'payouts'>, 'value'>
type StatementAssignableInformativePayoutLike = Pick<
  Tables<'payouts'>,
  'statement_id' | 'value'
> & {
  payout_installments?: Pick<Tables<'payout_installments'>, 'statement_id'>[] | null
}

export const isManualPayout = (payout?: ManualPayoutLike) => {
  return !payout?.compensation_rule_id && !payout?.target_id
}

export const isDiscrepancyAdjustment = (payout?: ManualPayoutLike) =>
  !!payout?.payout_discrepancy_id

export const isRegularManualPayout = (payout?: ManualPayoutLike) =>
  isManualPayout(payout) && !isDiscrepancyAdjustment(payout)

export const isClawbackPayout = (payout?: ClawbackPayoutLike) => {
  return !!payout?.clawback_id
}

export const isNegativeInformativePayout = (
  payout: InformativePayoutLike,
  rule: InformativePayoutRule | null | undefined
) =>
  payout.value < 0 &&
  rule?.long_term_balancing_period != null &&
  rule.long_term_balancing_clawback_method === 'informative'

export const isUnassignedNegativeInformativePayout = (
  payout: StatementAssignableInformativePayoutLike,
  rule: InformativePayoutRule | null | undefined
) =>
  payout.statement_id == null &&
  !payout.payout_installments?.some(installment => installment.statement_id != null) &&
  isNegativeInformativePayout(payout, rule)
